export const filterContentStyle = {
	filterGroup: {
		padding: '12px 0',

		'&:not(:last-child)': {
			borderBottom: '1px solid var(--neutral-100)',
		},
	},

	title: {
		padding: '0 16px',

		h6: {
			color: ' var(--neutral-300)',
		},
	},

	option: {
		padding: '8px 16px',
		display: 'flex',
		alignItems: 'center',
		cursor: 'pointer',

		'&:hover': {
			background: 'var(--background-grey-op-50-1)',
		},
	},

	selectOption: {
		justifyContent: 'space-between',
	},

	checkboxOption: {
		gap: '12px',

		'& svg path': {
			fill: 'var(--neutral-300)',
		},
	},
};
